import { cn } from "@/components/podkit/lib/cn";

// Visual-only styling for list items, titles, and descriptions. Use these
// to get the List look without the compound-component context or layout.

export const listClassName = cn(
    "divide-y divide-border-base overflow-clip rounded-xl border border-border-base bg-surface-secondary",
    "[&>*:first-child]:rounded-t-xl [&>*:last-child]:rounded-b-xl",
    // Round interactive children in first/last rows so the focus ring follows the container corners
    "[&>li:first-child>*]:rounded-t-xl [&>li:last-child>*]:rounded-b-xl",
);

export const listItemClassName = cn(
    "select-none",
    "hover:bg-surface-button-clear-accent duration-75",
    "data-[active=true]:bg-surface-button-clear-accent",
    "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-border-brand",
);

export const listItemTitleClassName = "text-base font-medium leading-tight text-content-primary";

export const listItemDescriptionClassName = "text-base leading-tight text-content-strong";
